// Shared tracePropagationTargets builder for browser Sentry SDKs (admin, product-app, public-web).
// Same-origin requests (relative paths) always propagate the trace; the cross-origin API base is added
// so browser/native traces stitch through to api-core. Pure (no Sentry/DOM dependency) so it lives in
// @fluentry/domain and stays unit-testable.

function escapeForRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function buildTracePropagationTargets(apiBaseUrl?: string | null): Array<string | RegExp> {
  const targets: Array<string | RegExp> = [/^\//];

  if (typeof apiBaseUrl === "string" && apiBaseUrl.length > 0) {
    targets.push(new RegExp(`^${escapeForRegExp(apiBaseUrl)}`));
  }

  return targets;
}
